import * as React from "react";
import Box from "@mui/material/Box";
// import { containerStyles } from "../style";

import Tabel from "./Tabel";
import Description from "./Description";
import { containerStyles } from "../style.js";

export default function IPIsolationDetail() {
  return (
    
    <Box id=""  sx={containerStyles}>
     
        <Description />
        <Tabel />
     
    </Box>
  );
}
